export default class ComarcaService {
    constructor(http, store) {
        this._http = http;
        this._store = store;
    }

    buscarUfs() {
        return this._http.post('consultaufs');
    }

    buscaDadosComarcas(uf) {
        return this._http.post('dados_comarcas', {
            uf: uf
        });
    }

    buscarComarcas(filtros) {
        return this._http.get('comarcas', {
            params: {
                cd_ibge_comarca: filtros.cd_ibge_comarca || undefined,
                nm_comarca: filtros.nm_comarca || undefined,
                cd_ibge_municipio: filtros.cd_ibge_municipio || undefined,
                nm_municipio: filtros.nm_municipio || undefined,
                cd_uf: filtros.cd_uf || undefined,
                cep_comarca: filtros.cep_comarca || undefined
            }
        });
    }

    editarComarcas(comarca) {
        return this._http.get(`comarcas/` + comarca.id);
    }

    salvarComarcas(comarca, idOriginal) {
        const id = idOriginal || comarca.id;
        return this._http.put(`comarcas/` + id, {
            cd_ibge_comarca: comarca.cd_ibge_comarca,
            nm_comarca: comarca.nm_comarca,
            cd_cep_abrangente_inicio: comarca.cd_cep_abrangente_inicio,
            cd_cep_abrangente_fim: comarca.cd_cep_abrangente_fim,
            ds_limite_diario: comarca.ds_limite_diario,
            st_ativo: comarca.st_ativo,
            requer_endosso: comarca.requer_endosso ? 1 : 0
        });
    }
}
